module.exports = __webpack_public_path__ + "img/company_happytablebi.100bd09f.jpg";